import { formatStringForSearch } from 'utils/helpers'

export default (text, query) => {
  if (!query) {
    return text
  }

  const formattedQuery = formatStringForSearch(query)
  const formattedText = formatStringForSearch(text)
  const iQuery = new RegExp(formattedQuery, 'ig')

  let result = text
  let offsetFix = 0

  formattedText.toString().replace(iQuery, (formattedMatched, offset, a, b) => {
    const realMatched = text.substr(offset, query.length)
    const highlightedMatched = `<span class='highlight'>${realMatched}</span>`

    result = result.slice(0, offset + offsetFix) + highlightedMatched + result.slice(offset + query.length + offsetFix)

    offsetFix += highlightedMatched.length - realMatched.length

    return highlightedMatched
  })

  return result
}
